import { useMutation, useQueryClient } from '@tanstack/react-query';
import { uploadLicense } from '@/lib/api';
import type { UploadLicenseRequest, UploadLicenseResponse } from '@/types/api';
import { licenseQueryKeys } from './useLicenseStatus';

export function useUploadLicense() {
  const queryClient = useQueryClient();

  return useMutation<UploadLicenseResponse, Error, UploadLicenseRequest>({
    mutationFn: uploadLicense,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: licenseQueryKeys.status() });
      queryClient.invalidateQueries({ queryKey: licenseQueryKeys.details() });
    },
  });
}
